/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1TargetgroupsQueryResponse } from '../../types/GetV1Targetgroups.ts'

export const getV1TargetgroupsQueryKey = () => [{ url: '/v1/TargetGroups' }] as const

export type GetV1TargetgroupsQueryKey = ReturnType<typeof getV1TargetgroupsQueryKey>

/**
 * {@link /v1/TargetGroups}
 */
export async function getV1Targetgroups(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1TargetgroupsQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/TargetGroups`,
        ...requestConfig,
    })
    return res
}

export function getV1TargetgroupsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1TargetgroupsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1TargetgroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1TargetgroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Targetgroups(config)
        },
    })
}

/**
 * {@link /v1/TargetGroups}
 */
export function useGetV1Targetgroups<
    TData = ResponseConfig<GetV1TargetgroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1TargetgroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1TargetgroupsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1TargetgroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1TargetgroupsQueryKey()

    const query = useQuery(
        {
            ...getV1TargetgroupsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
